import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Form, Formik } from 'formik';
import Button from "../../../components/buttons/Button";
import StyledHeadingText from "../../../components/Fonts/StyledHeadingText";
import InputField from "../../../components/inputFields/InputField";
import { toast } from "react-toastify";
import { newPatientPackageDoseComment } from "../../../services/new_clinic/new_hud_doses";

const NewDosePackageComment = ({ doseId, notes, onAddNewComment }) => {

    const handleSubmit = async (values, { setSubmitting }) => {
        setSubmitting(true);
        try {
            const response = await newPatientPackageDoseComment(doseId, values);
            if (response?.status === 200) {
                onAddNewComment();
                toast.success("Comment Updated successfully!");
            } else {
                toast.error("Oops! Something went wrong, please try again.");
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Oops! Something went wrong, please try again.";
            toast.error(errors);
        } finally {
            setSubmitting(false);
        }
    };

    const validationSchema = Yup.object({
        notes: Yup.string().required("Comment is required"),
    });

    return (
        <>
            <div className="w-full flex-1">
                <StyledHeadingText text="Package Comments" />
                <Formik
                    initialValues={{ notes: notes }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ isSubmitting, setFieldValue, values }) => (
                        <Form className="space-y-4 my-4">
                            <div className="flex gap-4 flex-col">
                                <InputField
                                    label={"Comment"}
                                    name="notes"
                                    type="text"
                                    placeholder="Enter your note here..."
                                    disable={notes}
                                    required
                                />
                                <Button
                                    type="submit"
                                    className="bg-primary text-white px-4 py-2 rounded max-w-32"
                                    disabled={isSubmitting || notes}
                                >
                                    {"Add"}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div >
        </>
    );
};

export default NewDosePackageComment;
